import { LayoutComponent } from '../layout/layout.component';
import * as login from './login';

export const routes = [

  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', loadChildren: './login/login.module#LoginModule'},


    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule'},
            { path: 'backups', loadChildren: './backups/listagem-backups.module#ListagemBackupsModule'},
            { path: 'ultimosBackups', loadChildren: './ultimos-backups/ultimos-backups.module#UltimosBackupsModule'},
            { path: 'restauracoes', loadChildren: './restauracoes/listagem-restauracoes.module#ListagemRestauracoesModule'},
            { path: 'planos', loadChildren: './planos/planos.module#PlanosModule'},
            { path: 'usuarios', loadChildren: './usuarios/usuarios.module#UsuariosModule'},
            { path: 'empresas', loadChildren: './empresas/empresas.module#EmpresasModule'},
            { path: 'configuracao', loadChildren: './configuracao/configuracao.module#ConfiguracaoModule'},
            { path: 'consultaDeLog', loadChildren: './consulta-de-log/consulta-de-log.module#ConsultaDeLogModule'}
        ]
    },

    // Not found
    { path: '**', redirectTo: 'login' }

];



// WEBPACK FOOTER //
// ./src/app/routes/routes.ts